module.exports = __webpack_public_path__ + "media/images/svg-icon/settings-610b04faaadffe20bd71b2af3aa48fbc.svg";